import { ButtonProps } from "@/types";

const variantClasses: Record<string, string> = {
  primary:
    "btn-gradient text-white shadow-[0_10px_30px_-16px_rgba(11,201,240,0.8)]",
  outline:
    "border border-[var(--stroke)] text-[var(--text)] hover:border-[var(--accent)]",
  ghost: "text-[var(--text)] hover:bg-[color:rgba(255,255,255,0.06)]",
};

export default function Button({
  className = "",
  variant = "primary",
  ...props
}: ButtonProps) {
  const classes = `inline-flex items-center justify-center gap-2 rounded-lg px-5 py-2 text-sm font-semibold transition ${
    variantClasses[variant]
  } ${className}`;

  return <button className={classes} {...props} />;
}
